/**
 * The `icon` use icon name from Font Awesome 6.7.2 (https://fontawesome.com/v6/search)
 * It is only used in Navigation Drawer and AppBar Avatar components.
 * Please register the icons you used as explained in `/docs/Customization.md`
 */
const avatarMenuItems = [
  {
    id: 'menuAccountSettings',
    title: 'Account Settings',
    icon: 'address-card',
    iconType: 'regular',
    action: 'accountSettings',
  },
  { divider: true },
  {
    id: 'menuLogout',
    title: 'Logout',
    icon: 'right-from-bracket',
    iconType: 'solid',
    action: 'logout',
  },
];

export default avatarMenuItems;
